import { Dispatch, SetStateAction } from 'react';

import { useAppDispatch } from '../../../../../../../store/hooks';
import { setActiveMandant } from '../../../../../../mandant/slices/mandant.slice';
import { LocalStorageProperties } from '../../../../../enums/local-storage-properties.enum';
import localStorageService from '../../../../../services/local-storage/local-storage.service';

export const useOnSelectMandant = (
  mandantId: number,
  toggleFn: Dispatch<SetStateAction<HTMLElement | null>>
): (() => void) => {
  const dispatch = useAppDispatch();
  // eslint-disable-next-line no-unused-vars
  return (): void => {
    localStorageService.set(LocalStorageProperties.SELECTED_MANDANT, mandantId);
    dispatch(setActiveMandant(mandantId));
    toggleFn(null);
  };
};
